import BenefitsModal from '../../../BenefitsModal';
import displayCurrency from '../../../../../../helpers/displayCurrency';
import { startCase } from 'lodash';
import { Field } from 'redux-form';
import { UpgradeOptionsCheckbox } from '../UpgradeOptionsCheckbox';
import React from 'react';
import '../PolicyUpgradesBox/styles.scss';

const UpgradeToGoldBox = ({
  hasGoldUpgrade,
  isGoldUpgraded,
  scheme,
  goldScheme,
  benefits,
  goldBenefits,
  upgradeDiff,
  onUpgradeToGold,
  boltOnList,
}) => {
  if (!hasGoldUpgrade) {
    return null;
  }
  const handleUpgradeSelect = (e) => {
    onUpgradeToGold(e.target.checked, goldScheme);
  };

  const displayBoltons = boltOnList.reduce((carry, boltOn, index) => {
    const boltonName = boltOn.replace(/_/g, ' ');
    if (carry && index === boltOnList.length - 1) {
      return `${carry} and ${startCase(boltonName)}`;
    }
    if (carry) {
      return `${carry}, ${startCase(boltonName)}`;
    }
    return startCase(boltonName);
  }, '');

  if (isGoldUpgraded) {
    return (
      <div className="upgrade-gold-box">
        <div className="update-gold-checkbox">
          <Field
            name={'travel_dispute'}
            component={UpgradeOptionsCheckbox}
            options={[{ name: 'Travel Dispute', value: true }]}
            onChange={handleUpgradeSelect}
            checkedValue={{ checked: isGoldUpgraded }}
          />
        </div>
        <div>
          <BenefitsModal scheme={scheme} benefits={benefits} />
          You've upgraded to a <span className="gold"> GOLD </span> package
          <div className="gold-sub">
            <small>(inclusive cover for {displayBoltons})</small>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="upgrade-gold-box">
      <div className="policy-upgrade-checkbox">
        <Field
          checkboxValue="travelDispute"
          name={'travel_dispute'}
          component={UpgradeOptionsCheckbox}
          options={[{ name: 'Travel Dispute', value: true }]}
          onChange={handleUpgradeSelect}
          checkedValue={{ checked: isGoldUpgraded }}
        />
      </div>
      <div>
        {boltOnList.length > 0 ? 'Or, upgrade' : 'Upgrade'} to a <span className="gold">
          {' '}
          GOLD{' '}
        </span> package for just
        <strong> {displayCurrency(upgradeDiff)} </strong>extra
        <BenefitsModal scheme={scheme} benefits={goldBenefits} />
        <div className="gold-sub">
          <small>(inclusive cover for {displayBoltons})</small>
        </div>
      </div>
    </div>
  );
};

export default UpgradeToGoldBox;
